import { z } from 'zod/v3';
import { ok } from 'neverthrow';
import {
  type ActionResult,
  type ApplicableContext,
  BaseAction,
  type ExecuteContext,
} from '@cotera/client/v0/actions/framework';
import type { ModalItem } from '@cotera/client/app/components/app/modal-manager/modal-manager';
import { pushNewTriggerModal } from './use-open-new-trigger-modal';

type Params = Record<string, never>;

type ModalManagerActions = {
  push: (item: ModalItem) => void;
  pop: () => void;
};

export class NewTriggerAction extends BaseAction<
  Params,
  { t: string; message?: string }[]
> {
  title = 'New Trigger';
  description = 'Create a new trigger';
  inputSchema = z.object({});
  group = 'Trigger';
  icon = 'trigger';

  constructor(
    private readonly modalManager: ModalManagerActions,
    private readonly navigate: (path: string) => void,
    private readonly orgSlug: string
  ) {
    super();
  }

  applicable(_context: ApplicableContext): boolean {
    return true;
  }

  async execute(
    _params: Params,
    _context: ExecuteContext
  ): Promise<ActionResult<{ t: string; message?: string }[]>> {
    pushNewTriggerModal(this.modalManager, {
      onCreated: () => this.navigate(`/${this.orgSlug}/triggers`),
    });
    return ok({});
  }
}
